/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'headerIcons/calendar': {
    width: 16,
    height: 18,
    viewBox: '0 0 16 18',
    data: '<path pid="0" d="M14.4 1.6h-.8V0H12v1.6H4V0H2.4v1.6h-.8C.72 1.6 0 2.32 0 3.2V16c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V3.2c0-.88-.72-1.6-1.6-1.6zm0 14.4H1.6V5.6h12.8V16z" _fill="#004CD0" fill-rule="evenodd"/>'
  }
})
